import { AfterViewInit, ElementRef, QueryList } from '@angular/core';
import { DTO } from '../../../app/core/models/dto';
import { environment } from '../../../environments/environment';
import { CashPipe } from '../../shared/pipes/cash.pipe';
var PromotionLeaderboardListTableComponent = /** @class */ (function () {
    function PromotionLeaderboardListTableComponent(route, leaderboardService, commonService) {
        this.route = route;
        this.leaderboardService = leaderboardService;
        this.commonService = commonService;
        this.countryCodes = {};
        this.cashPipe = new CashPipe('en');
        this.isRefreshable = true;
        this.environment = environment.env;
        this.wsopPrizeCustomList = {
            PROD: [43692],
            TEST: [27406]
        };
    }
    PromotionLeaderboardListTableComponent.prototype.checkSameUser = function (player) {
        var ret = false;
        if (this.brandId && this.siteId) {
            ret = player.nickname === this.parsedNickname && player.brandId.toUpperCase() === this.brandId.toUpperCase() && player.siteId.toUpperCase() === this.siteId.toUpperCase();
        }
        else if (this.brandId && !this.siteId) {
            ret = player.nickname === this.parsedNickname && player.brandId.toUpperCase() === this.brandId.toUpperCase();
        }
        return ret;
    };
    Object.defineProperty(PromotionLeaderboardListTableComponent.prototype, "isIndiaCountry", {
        get: function () {
            return this.countryCode === 'IN';
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PromotionLeaderboardListTableComponent.prototype, "parsedNickname", {
        get: function () {
            try {
                return atob(decodeURIComponent(this.nickname)).replace(/^YouCanSeeMe(.+)DoNotThis$/, '$1');
            }
            catch (e) {
                return '';
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PromotionLeaderboardListTableComponent.prototype, "isWsopPrizeCustom", {
        get: function () {
            var env = this.environment !== 'PROD' ? 'TEST' : this.environment;
            return this.wsopPrizeCustomList[env].indexOf(Number(this.promotionId)) > -1;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PromotionLeaderboardListTableComponent.prototype, "isChase", {
        get: function () {
            return [DTO.Enums.PromotionType.CHASE, DTO.Enums.PromotionType.TOURNAMENT_LEADERBOARD_CHASE].indexOf(this.type) !== -1;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PromotionLeaderboardListTableComponent.prototype, "isTournamentLeaderBoard", {
        get: function () {
            return this.type === DTO.Enums.PromotionType.TOURNAMENT_LEADERBOARD;
        },
        enumerable: true,
        configurable: true
    });
    PromotionLeaderboardListTableComponent.prototype.ngAfterViewInit = function () {
        this.listScrollToView(this.myRankMarking);
        this.listScrollToView(this.runningPrizeLevelMarking);
    };
    PromotionLeaderboardListTableComponent.prototype.listScrollToView = function (scrollTargetElements) {
        scrollTargetElements.changes.subscribe(function () {
            scrollTargetElements.toArray().forEach(function (el) {
                if (el.nativeElement.classList.contains('myRank')) {
                    el.nativeElement.scrollIntoView({ behavior: 'smooth' });
                }
            });
        });
    };
    PromotionLeaderboardListTableComponent.prototype.getCountry = function (countryCode) {
        return (this.countryCodes && this.countryCodes.hasOwnProperty(countryCode)) ? this.countryCodes[countryCode] : countryCode;
    };
    PromotionLeaderboardListTableComponent.prototype.wsopPrizeCustom = function (data) {
        var _this = this;
        var prize;
        var prizeITems = [];
        if (data.prizeItem) {
            data.prizeItem.map(function (item) {
                switch (item.currencyId) {
                    case 'GTD':
                        prizeITems.push(_this.cashPipe.transform(item.value, item.currencyId, 'symbol-narrow', '1.0-2'));
                        break;
                    default:
                        var description = JSON.parse(item.description);
                        prizeITems.push(description.name + " x " + item.quantity);
                        break;
                }
            });
            prize = "(" + prizeITems.join('+') + ")";
        }
        return prize;
    };
    return PromotionLeaderboardListTableComponent;
}());
export { PromotionLeaderboardListTableComponent };
